import { render, staticRenderFns } from "./ProgramTestDistributionGraph.vue?vue&type=template&id=6c940c1f&scoped=true"
import script from "./ProgramTestDistributionGraph.vue?vue&type=script&lang=js"
export * from "./ProgramTestDistributionGraph.vue?vue&type=script&lang=js"
import style0 from "./ProgramTestDistributionGraph.vue?vue&type=style&index=0&id=6c940c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c940c1f",
  null
  
)

export default component.exports